import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import { useAuthentication } from './Session';
import useFirebase from './Firebase';
import {
  Button,
  AppBar,
  Toolbar,
  IconButton,
  MenuItem,
  Menu,
  makeStyles,
  Typography
} from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';

const Navigation = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const authUser = useAuthentication();
  const history = useHistory();
  const classes = useStyles();
  console.debug('calling Navigation', authUser);

  const goTo = route => e => {
    history.push(route);
    e.preventDefault();
  };

  useEffect(() => {
    if (authUser) {
      console.debug(`authUser: ${JSON.stringify(authUser)}`);
      setIsAdmin(authUser && authUser.role === 'admin');
      setIsSignedIn(authUser && authUser.authenticated === true);
    }
  }, [authUser]);

  return (
    <AppBar position="static" className={classes.root}>
      <Toolbar>
        <Typography variant="h6" className={classes.title}>
          Autote
        </Typography>
        {isSignedIn && (
          <Button onClick={goTo(ROUTES.TRANSCRIPTION_LIST)} color="inherit">
            Transcriptions
          </Button>
        )}
        {isSignedIn && isAdmin && (
          <Button onClick={goTo(ROUTES.ADMIN)} color="inherit">
            Admin
          </Button>
        )}
        {isSignedIn && <ProfileMenu />}
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    '@media print': {
      display: 'none'
    }
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  }
}));

const ProfileMenu = () => {
  const history = useHistory();
  const firebase = useFirebase();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const doSignOut = e => {
    firebase
      .doSignOut()
      .then(() => {
        history.push(ROUTES.SIGN_IN);
      })
      .catch(e => console.error(e));
    e.preventDefault();
  };

  return (
    <div>
      <IconButton
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleMenu}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => history.push(ROUTES.ACCOUNT)}>
          My account
        </MenuItem>
        <MenuItem onClick={doSignOut}>SignOut</MenuItem>
      </Menu>
    </div>
  );
};

export default Navigation;
